// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","navbar_content":"Navbar_navbar_content__fhfYb","navbar_logo":"Navbar_navbar_logo__RZhA+","navbar_menu":"Navbar_navbar_menu__enIzd"};